import React, { useEffect, useState } from "react";

import ParametersCards from "./ParametersCards";
import LookupsAPI from "../../API/lookups.api";
import { MODEL_PROCESSING_TYPES, UNITS } from "../../utils/constants";
import { isEmpty } from "lodash";

const ParametersForm = ({
    parameters,
    setParameters,
    activeUnit,
    setActiveUnit,
    showAddParameter,
    hideParameterDeleteIcon,
    error,
    isFormSubmitted,
    disableEditingName,
    showAddUnit = true,
    isEdit = false,
    showClassificationOption = false,
    updateClassificationParameters,
    parameterUnitsMaps,
    isDynamicSorted,
    isCustom,
}) => {
    const [units, setUnits] = useState([]);
    const [existingUnitsHandled, setExistingUnitsHandled] = useState(false);
    const [existingParametersHandled, setExistingParametersHandled] =
        useState(false);
    const [conversionUnits, setConversionUnits] = useState([]);
    const [defaultConversions, setDefaultConversions] = useState([]);

    const [isUnitsLoading, setIsUnitsLoading] = useState(false);
    const [conversionUnitsLoading, setConversionUnitsLoading] = useState(false);

    useEffect(() => {
        if (!isEdit) {
            fetchUnitsLookup();
            fetchDefaultConversionUnits();
        }
    }, []);
    useEffect(() => {
        if (!isParametersIdentified()) {
            addParametersIdentity();
        }
    }, [parameters]);

    useEffect(() => {
        if (isEdit && !isEmpty(parameters) && !existingUnitsHandled) {
            const parameterDetails = [...parameters[0]?.parameterDetails];
            const baseUnit = parameterDetails.splice(0, 1);
            const baseUnitId = baseUnit[0]?.unit?.value;
            const existingConversionUnitIds = parameterDetails.map(
                (pd) => pd.unit.value
            );
            fetchConversionUnitsLookup(
                baseUnitId,
                0,
                existingConversionUnitIds
            );
            setExistingUnitsHandled(true);
        }
    }, [parameters]);

    useEffect(() => {
        if (
            !isEmpty(parameters) &&
            !isEmpty(defaultConversions) &&
            !existingParametersHandled
        ) {
            setExistingParametersHandled(true);
            if (parameters.length > 1) {
                setConversionUnits(
                    Array(parameters.length).fill(defaultConversions)
                );
            }
        }
    }, [parameters, defaultConversions]);

    //Check wether each parameter has fake id or not
    const isParametersIdentified = () => {
        for (const parameter of parameters) {
            if (!parameter.fakeId) return false;
        }
        return true;
    };

    //Add fake id to unidentified parameters
    const addParametersIdentity = () => {
        setParameters((prevParameters) => {
            return prevParameters.map((parameter) =>
                parameter?.fakeId
                    ? parameter
                    : { ...parameter, fakeId: _.uniqueId() }
            );
        });
    };

    const handleBaseUnitChange = (parameterIndex, value) => {
        fetchConversionUnitsLookup(value.value, parameterIndex);
    };

    const fetchUnitsLookup = async () => {
        setIsUnitsLoading(true);
        const result = await LookupsAPI.getUnits();
        setUnits(result);
        setIsUnitsLoading(false);
    };

    const fetchDefaultConversionUnits = async () => {
        const result = await LookupsAPI.getLinkedUnitConversions(
            UNITS.percentage.value
        );
        setDefaultConversions(result);
        setConversionUnits([result]);
    };

    const fetchConversionUnitsLookup = async (
        baseUnitId,
        parameterIndex,
        existingConversionUnitIds
    ) => {
        setConversionUnitsLoading(true);
        const result = await LookupsAPI.getLinkedUnitConversions(baseUnitId);
        setConversionUnits((prevConversions) => {
            const newConversion = [...prevConversions];
            const mappedResult = existingConversionUnitIds
                ? result.filter(
                      (unit) => !existingConversionUnitIds.includes(unit.value)
                  )
                : result;
            newConversion[parameterIndex] = mappedResult;
            return newConversion;
        });
        setConversionUnitsLoading(false);
    };

    const getEmptyParameter = () => ({
        name: "",
        ...(showClassificationOption && {
            type: MODEL_PROCESSING_TYPES.Regression,
        }),
        localizations: { en: "" },
        parameterDetails: [
            {
                unit: UNITS.percentage,
                decimalPlaces: 2,
            },
        ],
    });

    const addNewParameterCard = () => {
        setParameters((prevParams) => [...prevParams, getEmptyParameter()]);
        setConversionUnits((prevConversion) => [
            ...prevConversion,
            defaultConversions,
        ]);
        setActiveUnit((prevUnits) => [...prevUnits, 1]);
    };

    return (
        <>
            <ParametersCards
                parameters={parameters}
                setParameters={setParameters}
                addParameterHandler={addNewParameterCard}
                units={units}
                conversionUnits={conversionUnits}
                setConversionUnits={setConversionUnits}
                handleBaseUnitChange={handleBaseUnitChange}
                activeUnit={activeUnit}
                setActiveUnit={setActiveUnit}
                showAddUnit={showAddUnit}
                showAddParameter={showAddParameter}
                error={error}
                isFormSubmitted={isFormSubmitted}
                disableEditingName={disableEditingName}
                hideParameterDeleteIcon={hideParameterDeleteIcon}
                isEdit={isEdit}
                conversionUnitsLoading={conversionUnitsLoading}
                isUnitsLoading={isUnitsLoading}
                showClassificationOption={showClassificationOption}
                updateClassificationParameters={updateClassificationParameters}
                parameterUnitsMaps={parameterUnitsMaps}
                isDynamicSorted={isDynamicSorted}
                isCustom={isCustom}
            />
        </>
    );
};

export default ParametersForm;
